module.exports = __webpack_public_path__ + "03_hair_brown.5a2668de.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/03_hair_brown.png
// module id = H2et
// module chunks = 0